import { render, staticRenderFns } from "./TipsHbrb.vue?vue&type=template&id=062b89ec&scoped=true"
import script from "./TipsHbrb.vue?vue&type=script&lang=js"
export * from "./TipsHbrb.vue?vue&type=script&lang=js"
import style0 from "./TipsHbrb.vue?vue&type=style&index=0&id=062b89ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062b89ec",
  null
  
)

export default component.exports